module.exports = __webpack_public_path__ + "static/media/mcdac.60464810.png";